<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Reply to Concierge'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      @if (windowService.isDesktopRes) {
        <tidy-alert>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="statusIcon"
              class="header-size" />
            @if (item?.type !== 'support.concierge_task') {
              <tidy-text
                [header]="item?.header_text" />
            }
            @if (item?.type === 'support.concierge_task') {
              <tidy-text
                [header]="item?.components?.[0]?.value?.subject" />
            }
          </tidy-row>
          @if (item?.components?.[0]?.value?.status !== 'completed' && item?.components?.[0]?.value?.status !== 'closed') {
            <tidy-row>
              @if (item?.components?.[0]?.value?.status === 'waiting_on_tidy') {
                <tidy-text
                  [body]="'<i>Waiting on TIDY</i>'" />
              }
              @if (item?.components?.[0]?.value?.status === 'waiting_on_customer') {
                <tidy-text
                  [body]="'<b><i>Waiting on You</i><b>'" />
              }
            </tidy-row>
            <tidy-row>
              @if (item?.metadata?.request_data?.scheduled === 'Immediate' || item?.metadata?.request_data?.scheduled === 'immediate') {
                <tidy-text
                  [body]="'<i>Scheduled to do immediately</i>'" />
              }
              @if (item?.metadata?.request_data?.scheduled && item?.metadata?.request_data?.scheduled !== 'Immediate' && item?.metadata?.request_data?.scheduled !== 'immediate') {
                <tidy-text
                  [body]="'<i>Scheduled to do on'" /><span>&nbsp;</span>
                  <tidy-text
                  [body]="(item?.metadata?.request_data?.scheduled | parseDateTime: 'MMM d') + '</i>'" />
              }
            </tidy-row>
          }
        </tidy-alert>
        @for (comment of comments; track comment.id) {
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text
                [header]="((comment?.user_type === 'Customer' || comment?.user_type === 'customer' || comment?.user_type === 'CustomerMember') ? ('You' | translate) : ('TIDY Concierge' | translate))" />
              <tidy-text
                [helper]="(comment?.created_at | parseDateTime:'MMM d':'local') + ' ' + (comment?.created_at | parseDateTime:'h:mma':'local')" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [checkLineBreaks]="true"
                [linkify]="true"
                [body]="comment?.content" />
            </tidy-row>
            @if (comment?.attachments?.length > 0) {
              <tidy-row>
                <tidy-text body="Attachments:" />
              </tidy-row>
              @for (attachment of comment?.attachments; track attachment) {
                <tidy-row>
                  <tidy-text
                    [body]="attachment.split('/').pop()"
                    (action)="openAttachment(attachment)"
                    class="link" />
                </tidy-row>
              }
            }
          </tidy-card>
        }
        <tidy-card>
          <form [formGroup]="form" novalidate action="#">
            <tidy-row class="field-top-padding">
              <tidy-textarea
                [label]="'Reply'"
                formControlName="content"
                [form]="form.controls.content"
                [submitted]="submitted"
                [icon]="'assets/svg/information-circle.svg'"
                [errorMessage]="'Please enter a reply.'" />
            </tidy-row>
          </form>
          <tidy-row class="field-top-padding">
            <tidy-text
              [actionBody]="'Add Attachment'"
              (action)="addAttachment()"
              class="link" />
          </tidy-row>
          @if (attachments.length) {
            <tidy-row class="field-top-padding">
              <tidy-row>
                <tidy-text
                  [body]="'Attachments:'" />
              </tidy-row>
              @for (attachment of attachments; track attachment; let i = $index) {
                <tidy-two-column-row>
                  <tidy-text
                    [body]="attachment.filename" />
                  <tidy-text
                    [actionBody]="'remove'"
                    (action)="removeAttachment(i)"
                    class="link red" />
                </tidy-two-column-row>
              }
            </tidy-row>
          }
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Send Reply'"
          [action]="boundSend"
          class="primary" />
      }
      @if (!windowService.isDesktopRes) {
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="statusIcon"
              class="header-size" />
            @if (item?.type !== 'support.concierge_task') {
              <tidy-text
                [header]="item?.header_text" />
            }
            @if (item?.type === 'support.concierge_task') {
              <tidy-text
                [header]="item?.components?.[0]?.value?.subject" />
            }
          </tidy-row>
          @if (item?.components?.[0]?.value?.status !== 'completed' && item?.components?.[0]?.value?.status !== 'closed') {
            <tidy-row>
              @if (item?.components?.[0]?.value?.status === 'waiting_on_tidy') {
                <tidy-text
                  [body]="'<i>Waiting on TIDY</i>'" />
              }
              @if (item?.components?.[0]?.value?.status === 'waiting_on_customer') {
                <tidy-text
                  [body]="'<b><i>Waiting on You</i><b>'" />
              }
            </tidy-row>
          }
          <tidy-row class="extra-bottom-padding extra-top-padding">
            <tidy-divider />
          </tidy-row>
          @if (comments?.length > 0) {
            <div class="scrollable-comments-container">
              @for (comment of comments; track comment.id) {
                <tidy-card>
                  <tidy-row [alignLastItemRight]="true">
                    <tidy-text
                      [header]="((comment?.user_type === 'Customer' || comment?.user_type === 'customer' || comment?.user_type === 'CustomerMember') ? ('You' | translate) : ('TIDY Concierge' | translate))" />
                    <tidy-text
                      [helper]="(comment?.created_at | parseDateTime:'MMM d':'local') + ' ' + (comment?.created_at | parseDateTime:'h:mma':'local')" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [checkLineBreaks]="true"
                      [linkify]="true"
                      [body]="comment?.content" />
                  </tidy-row>
                  @if (comment?.attachments?.length > 0) {
                    <tidy-row>
                      <tidy-text body="Attachments:" />
                    </tidy-row>
                    @for (attachment of comment?.attachments; track attachment) {
                      <tidy-row>
                        <tidy-text
                          [body]="attachment.split('/').pop()"
                          (action)="openAttachment(attachment)"
                          class="link" />
                      </tidy-row>
                    }
                  }
                </tidy-card>
              }
            </div>
          }
          <form [formGroup]="form" novalidate action="#">
            <tidy-row class="field-top-padding">
              <tidy-textarea
                [label]="'Reply'"
                formControlName="content"
                [form]="form.controls.content"
                [submitted]="submitted"
                [icon]="'assets/svg/information-circle.svg'"
                [errorMessage]="'Please enter a reply.'" />
            </tidy-row>
          </form>
          <tidy-row class="field-top-padding">
            <tidy-text
              [actionBody]="'Add Attachment'"
              (action)="addAttachment()"
              class="link" />
          </tidy-row>
          @if (attachments.length) {
            <tidy-row class="field-top-padding">
              <tidy-row>
                <tidy-text
                  [body]="'Attachments:'"
                  />
              </tidy-row>
              @for (attachment of attachments; track attachment; let i = $index) {
                <tidy-two-column-row>
                  <tidy-text
                    [body]="attachment.filename" />
                  <tidy-text
                    [actionBody]="'remove'"
                    (action)="removeAttachment(i)"
                    class="link red" />
                </tidy-two-column-row>
              }
            </tidy-row>
          }
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Send Reply'"
          [action]="boundSend"
          class="primary" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
